
























import { computed, defineComponent, ref, toRef, watch } from '@vue/composition-api';
export default defineComponent({
    props: {
        avatar: String,
        verified: Boolean,
        verifiedDetail: Object,
        size: String,
    },
    setup(props) {

        const vClass = computed(() => {
            switch (props.verifiedDetail?.iconType) {
                case 1:
                    return 'avatar-v-orange';
                case 2:
                    return 'avatar-v-blue';
                case 3:
                    return 'avatar-v-music';
                default:
                    return '';
            }
        });
        const showDefault = ref(false);
        return {
            vClass,
            showDefault,
        };
    },
});
